"use client";

import { SolutionSection } from "@/components/sections/solution";
import { solution } from "@/lib/data/services-social-media-marketing";

export function Solution() {
  return (
    <SolutionSection
      eyebrow={solution.eyebrow}
      title={solution.title}
      intro={solution.intro}
      pillars={solution.pillars}
      cta={solution.cta}
      accent={solution.accent}
      pillarAccents={solution.pillarAccents}
    />
  );
}
